/*
 * Filter names for popup in the fiters header
 */
export const PROPERTY = 'Property'
export const ASSET_TYPE = 'Asset Type'
export const AUCTION_TYPE = 'Buying Type'
export const CONDITION = 'Condition'
export const MORE = 'More Filters'
export const FEATURED = 'Featured'
export const ALL = 'Sort & Filter'
export const POPULAR = 'Popular'

/*
 * Property Filters Options
 */
export const BEDS_OPTIONS = [
  { key: 'beds_min_any', value: 'any', text: 'Any' },
  { key: 'beds_min_1', value: '1', text: '1+ Beds' },
  { key: 'beds_min_2', value: '2', text: '2+ Beds' },
  { key: 'beds_min_3', value: '3', text: '3+ Beds' },
  { key: 'beds_min_4', value: '4', text: '4+ Beds' },
]
export const BATHS_OPTIONS = [
  { key: 'baths_min_any', value: 'any', text: 'Any' },
  { key: 'baths_min_1', value: '1', text: '1+ Baths' },
  { key: 'baths_min_2', value: '2', text: '2+ Baths' },
  { key: 'baths_min_3', value: '3', text: '3+ Baths' },
  { key: 'baths_min_4', value: '4', text: '4+ Baths' },
]

export const allListingTypesSelected = ['pending', 'closed', 'canceled']
export const activeListingTypeSelected = ['active']
export const interiorAccessSelected = 'y'
export const financingAvailableSelected = 'y'
export const maoFilterSelected = 'y'
export const moreAllListingFilters = 'all_filters'
export const brokerCoopAvailableSelected = 'y'
export const hideEndingSoonSelected = 'y'
export const noBuyerPremiumFilterSelected = 'n'
export const showReserveSelected = 'y'
export const vacantOccupancyStatus = ['vacant']

export const NEARBY_SEARCH_RADIUS_OPTIONS = [
  {
    key: '5',
    text: '5 Miles',
    value: 5,
  },
  {
    key: '10',
    text: '10 Miles',
    value: 10,
  },
  {
    key: '25',
    text: '25 Miles',
    value: 25,
  },
  {
    key: '50',
    text: '50 Miles',
    value: 50,
  },
  {
    key: '100',
    text: '100 Miles',
    value: 100,
  },
]

/*
 * Property Filters elmId
 */
export const PROPERTY_ELM_ID = 'property'
export const ASSET_TYPE_ELM_ID = 'asset_type'
export const AUCTION_TYPE_ELM_ID = 'auction_type'
export const CONDITION_ELM_ID = 'condition'
export const FEATURED_ELM_ID = 'marketingTag'
export const MORE_ELM_ID = 'more'
export const ALL_ELM_ID = 'all'
export const FILTERS_NAME_ARRAY = [
  PROPERTY_ELM_ID,
  ASSET_TYPE_ELM_ID,
  AUCTION_TYPE_ELM_ID,
  CONDITION_ELM_ID,
  MORE_ELM_ID,
  ALL_ELM_ID,
  FEATURED_ELM_ID,
]
export const POPULAR_ELM_ID = 'popular'
